import { ArrowLeft, Leaf } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Header } from "@/components/Header";
import { AnimatedSection } from "@/components/AnimatedSection";

const ProgramasAmbientais = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-blue-600 relative overflow-x-hidden">
      <Header />
      
      <div className="pt-20 sm:pt-24">
        {/* Hero Section with Gradient */}
        <section className="relative w-full">
          <div className="absolute inset-0 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-950"></div>
          <article className="relative z-10 flex flex-col justify-center items-center text-center xl:max-w-5xl gap-4 text-xl text-white mx-auto py-16 px-4 lg:py-24 lg:px-16 xl:px-28">
            <Leaf className="w-16 h-16 mb-2" />
            <h1 className="text-3xl sm:text-4xl font-bold">Programas Ambientais</h1>
            <p className="max-w-2xl">
              Desenvolvemos e implementamos programas ambientais completos para monitoramento, 
              preservação e gestão sustentável de recursos hídricos e ecossistemas.
            </p>
          </article>
        </section>

        {/* Content Section */}
        <section className="py-10 sm:py-16 bg-gray-50">
          <div className="container mx-auto px-4 sm:px-6 max-w-5xl">
            <AnimatedSection delay={100}>
              <div className="bg-white rounded-lg shadow-lg p-8 sm:p-12 text-center">
                <h2 className="text-2xl sm:text-3xl font-bold text-blue-600 mb-4">
                  Em Desenvolvimento
                </h2>
                <p className="text-gray-700 text-lg mb-8 max-w-2xl mx-auto">
                  Esta seção está sendo desenvolvida e estará disponível em breve. 
                  Aqui você encontrará informações detalhadas sobre nossos programas ambientais, 
                  incluindo monitoramento de qualidade da água, gestão de bacias hidrográficas 
                  e iniciativas de sustentabilidade.
                </p>
                <button 
                  onClick={() => navigate('/')}
                  className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 hover:border-blue-400 hover:scale-105 py-3 px-8 font-semibold text-white rounded-xl text-sm uppercase transition-all duration-200 border border-blue-700"
                >
                  <ArrowLeft className="w-4 h-4" />
                  <strong>Voltar ao Início</strong>
                </button>
              </div>
            </AnimatedSection>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ProgramasAmbientais;
